var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.routerType ? "OldBackground" : "Count",
      staticStyle: { width: "100%", "min-height": "800px" }
    },
    [
      _c(
        "div",
        { staticClass: "header-wrap", staticStyle: { "z-index": "9999" } },
        [
          _c(
            "div",
            {
              staticClass: "header",
              class: _vm.routerType ? "showType" : "",
              style: _vm.routerType ? "max-width:100%" : "max-width:1098px"
            },
            [
              _c(
                "div",
                {
                  staticClass: "wrap_l",
                  staticStyle: { cursor: "pointer" },
                  on: {
                    click: function($event) {
                      return _vm.pathIndex()
                    }
                  }
                },
                [
                  _c("img", {
                    staticStyle: { float: "left" },
                    attrs: { src: require("../assets/logo.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        float: "left",
                        "font-size": "16px",
                        "margin-left": "60px"
                      },
                      on: {
                        click: function($event) {
                          return _vm.shouType(1)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("i18n_home")) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        float: "left",
                        "font-size": "16px",
                        "margin-left": "30px"
                      },
                      on: {
                        click: function($event) {
                          return _vm.shouType(2)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("i18n_Tracking")) +
                          "\n        "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "wrap_R",
                  staticStyle: { "margin-right": "30px" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-right": "30px",
                        "font-weight": "bold",
                        "line-height": "1"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("i18n_Contact_hotline")) +
                          " 181-0280-6672\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.$store.state.Authorization
                    ? _c("div", { on: { click: _vm.openLogin } }, [
                        _c("div", { staticClass: "loginBtn" }, [
                          _vm._v(_vm._s(_vm.$t("i18n_Quick_Login")))
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$store.state.Authorization
                    ? _c(
                        "div",
                        {
                          staticClass: "zhuce",
                          staticStyle: { float: "left" },
                          on: { click: _vm.logonShow }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("i18n_sign_up")) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.state.Authorization
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-dropdown",
                            {
                              attrs: { trigger: "click" },
                              on: { command: _vm.PathTo }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "el-dropdown-link",
                                  staticStyle: {
                                    color: "#ffffff",
                                    "font-size": "16px",
                                    "line-height": "1"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$store.state.Authorization.namec
                                      ) +
                                      "\n              "
                                  ),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-arrow-down el-icon--right"
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown"
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "a" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("i18n_Personal_Center"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "b" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("i18n_Check_Pricing_and_order")
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "c", divided: "" } },
                                    [_vm._v(_vm._s(_vm.$t("i18n_Log_out")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      !_vm.routerType && !_vm.topType
        ? _c(
            "div",
            { staticClass: "lang-change" },
            [
              _c(
                "el-dropdown",
                {
                  staticClass: "margin-right-lg user-btn",
                  attrs: { trigger: "click" },
                  on: { command: _vm.langChange }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "el-dropdown-link",
                      staticStyle: { color: "white", "font-size": "16px" }
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "15px", height: "15px" },
                        attrs: { src: require("@/assets/earth.png") }
                      }),
                      _vm._v(
                        "\n        " + _vm._s(_vm.lang === "zh" ? "中文" : "EN")
                      ),
                      _c("i", {
                        staticClass: "el-icon-arrow-down el-icon--right"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c("el-dropdown-item", { attrs: { command: "zh" } }, [
                        _vm._v("中文")
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", { attrs: { command: "en" } }, [
                        _vm._v("EN")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _vm.showRefresh
        ? _c("div", { staticClass: "refreshTip" }, [
            _c(
              "div",
              { staticClass: "top" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      icon: "el-icon-refresh-right",
                      type: "success",
                      size: "mini",
                      plain: ""
                    },
                    on: { click: _vm.refreshWindow }
                  },
                  [_vm._v(_vm._s(_vm.countdown) + "秒后自动刷新")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "tip-text" }, [
              _vm._v("系统版本有更新，刷新后立即使用！")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("loginType", { ref: "child", on: { openRegister: _vm.openRegister } }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "476px",
            visible: _vm.dialogFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c("el-tab-pane", {
                attrs: { label: _vm.$t("i18n_Personal_Account"), name: "first" }
              }),
              _vm._v(" "),
              _c("el-tab-pane", {
                attrs: {
                  label: _vm.$t("i18n_Business_Account"),
                  name: "second"
                }
              }),
              _vm._v(" "),
              _c("el-tab-pane", {
                attrs: { label: _vm.$t("i18n_Internation_User"), name: "third" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tabsCount" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { rules: _vm.rules, model: _vm.userForm }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: _vm.$t(
                            _vm.activeName == "first"
                              ? "i18n_Name"
                              : "i18n_Please_enter_your_business_name"
                          )
                        },
                        model: {
                          value: _vm.userForm.name,
                          callback: function($$v) {
                            _vm.$set(_vm.userForm, "name", $$v)
                          },
                          expression: "userForm.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "phoneNo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: _vm.$t(
                            _vm.activeName == "third"
                              ? "i18n_Please_enter_your_contact_number"
                              : "i18n_Please_enter_you_phone_number"
                          )
                        },
                        model: {
                          value: _vm.userForm.phoneNo,
                          callback: function($$v) {
                            _vm.$set(_vm.userForm, "phoneNo", $$v)
                          },
                          expression: "userForm.phoneNo"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.activeName == "third"
                    ? _c(
                        "el-form-item",
                        { attrs: { prop: "email" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: _vm.$t(
                                "i18n_please_enter_your_working_email"
                              )
                            },
                            model: {
                              value: _vm.userForm.email,
                              callback: function($$v) {
                                _vm.$set(_vm.userForm, "email", $$v)
                              },
                              expression: "userForm.email"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "password" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          type: "password",
                          placeholder: _vm.$t("i18n_Password")
                        },
                        model: {
                          value: _vm.userForm.password,
                          callback: function($$v) {
                            _vm.$set(_vm.userForm, "password", $$v)
                          },
                          expression: "userForm.password"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "comPassword" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          type: "password",
                          placeholder: _vm.$t("i18n_Confirm_Password")
                        },
                        model: {
                          value: _vm.userForm.comPassword,
                          callback: function($$v) {
                            _vm.$set(_vm.userForm, "comPassword", $$v)
                          },
                          expression: "userForm.comPassword"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { prop: "verificationCode" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "center_Style",
                        staticStyle: { width: "100%" }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              staticStyle: { width: "266px" },
                              attrs: {
                                clearable: "",
                                placeholder: _vm.$t(
                                  _vm.activeName == "third"
                                    ? "i18n_email_verification_code"
                                    : "i18n_SMS_Verification_Code"
                                )
                              },
                              model: {
                                value: _vm.userForm.verificationCode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.userForm,
                                    "verificationCode",
                                    $$v
                                  )
                                },
                                expression: "userForm.verificationCode"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { "margin-left": "10px" } },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { width: "160px" },
                                attrs: { type: "primary", plain: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.sendCode()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.countDown <= 0
                                      ? _vm.$t(
                                          "i18n_Receive_SMS_verification_code"
                                        )
                                      : _vm.countDown + "s"
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { padding: "15px 0", "text-align": "right" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("i18n_I_have_been_read")) + "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      attrs: { "data-v-9aa3ee46": "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toPolicy()
                        }
                      }
                    },
                    [_vm._v("《" + _vm._s(_vm.$t("i18n_citi_term")) + "》")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              staticStyle: { "padding-bottom": "50px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "100%" },
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.validateForm("form")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("i18n_Sign_up_Now")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "服务条款",
            center: "",
            visible: _vm.registerPolicyDialog,
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.registerPolicyDialog = $event
            }
          }
        },
        [
          _c("div", {}, [
            _c("p", { staticStyle: { "font-size": "26px" } }, [
              _vm._v("服务条款")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("协议构成及须知")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        1.\n        本协议是亦邦物流网络平台注册用户（包括使用亦邦物流网络平台的个人和所代表的企业）与亦邦物流网络平台之间的法律契约，注册亦邦物流网络平台即代表接受本协议的约束，并自注册成功之时即成为本协议的一方（即亦邦物流用户）且自发出协议之时即受协议条款的约束。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        2.\n        本协议受中华人民共和国法律管辖，签约地为深圳。下文中的亦邦物流是本协议的契约方之一。下文中的“用户”指亦邦物流网络平台注册用户，是本协议的契约方之另一方。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        3.\n        用户欲访问和使用亦邦物流网络平台，必须事先认真阅读本协议中的各项条款，包括免除或者限制亦邦物流网络平台责任的免责条款及对用户的权利限制。请审阅并选择接受或不接受本协议。如不同意本协议条款或随时对其的修改，请不使用或主动取消亦邦物流网络平台提供的服务。对亦邦物流网络平台的使用行为将被视为对本协议条款的完全接受，包括接受亦邦物流网络平台对条款所做的任何修改。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticStyle: { "font-size": "22px" } }, [
              _vm._v("用户使用规则")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        1.\n        亦邦物流网络平台服务仅限于为用户提供正常和合法业务工具，用户如果使用亦邦物流网络平台产品从事以下行为，即导致根本性违约，亦邦物流网络平台有权随时停止服务、解除本协议，并追讨因此带来的损失：\n        1）有明确证据表明用户使用亦邦物流网络平台用于违反法律的业务。用户发送了任何妨碍社会治安或非法、虚假、骚扰性、侮辱性、恐吓性、伤害性、破坏性、挑衅性、淫秽等内容的信息。\n        2）对亦邦物流网络平台产品进行了任何形式的对其他第三方的再授权使用，销售或转让。\n        3）提供的公司信息或个人资料不真实，或有可能对亦邦物流网络平台其他用户构成误导甚至欺诈。\n        4）滥用亦邦物流网络平台产品的通信功能发送垃圾邮件和短信。\n        5）对亦邦物流网络平台的连续服务和商誉构成损害的其他行为，包括对亦邦物流网络平台服务器的攻击。\n        6）其他亦邦物流网络平台认为是不符合整体服务需求的特殊情形。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        2.\n        亦邦物流网络平台使用用户所拥有的互联网域名所对应的电子邮件地址作为用户权证的唯一识别信息。当用户不再拥有在亦邦物流网络平台所登记的域名时，亦邦物流网络平台有权随时删除该用户的所有数据。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        3.\n        用户必须自行配备上网和使用电信增值业务所需的设备，自行负担上网或第三方（包括但不限于电信或移动通信提供商）收取的通讯费、信息费等有关费用。如涉及电信增值服务的，请与您的电信增值服务提供商确认相关的费用问题。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticStyle: { "font-size": "22px" } }, [
              _vm._v("知识产权")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        1.\n        用户完全拥有在使用亦邦物流网络平台时创建的数据和资料（包括但不限于：货物资料、价格数据、客户资料、联系人等信息）的所有权，并有权进行任何形式的处置，包括从亦邦物流网络平台中复制、导出和删除。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        2.\n        亦邦（深圳）国际物流有限公司完全拥有亦邦物流网络平台的全部知识产权，用户签署本协议后并未拥有亦邦物流网络平台的所有权。亦邦（深圳）国际物流有限公司的公司名称、标志、LOGO、产品名字，以及亦邦物流网络平台的应用程序、源代码、界面设计、应用程序编程接口（API）等所关联的知识产权都归属亦邦（深圳）国际物流有限公司，未经授权不能使用。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        3.\n        用户不得将涉及亦邦物流网络平台拥有知识产权的相关内容用于本协议范围以外的任何商业目的或泄露给第三方。用户不得出售、转售或复制亦邦物流网络平台产品，亦不可基于商业目的模仿亦邦物流网络平台的产品和服务。用户不可复制和模仿亦邦物流网络平台的设计理念、界面、功能和文字及图形说明。未经亦邦（深圳）国际物流有限公司许可，用户不得基于此协议所约定的服务对亦邦物流网络平台进行修改或制造、衍生其它产品。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticStyle: { "font-size": "22px" } }, [
              _vm._v("数据安全及保密")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        1.\n        亦邦物流网络平台每天都对用户储存在亦邦物流服务器上的数据信息进行异地备份，做好冗灾预防机制，以确保在系统发生问题后，可以快速恢复系统正常运行。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        2.\n        用户有义务维护自己在亦邦物流网络平台中的账户信息的完整性、密码的保密性。因用户维护或保密不善致使相关信息泄露，或由于第三方盗用用户帐号和密码进行各种操作而造成的损失，由用户自行负责。用户不得向他人提供亦邦物流网络平台的全部或部分服务，也不得容许他人通过自己的账户使用亦邦物流网络平台。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        3.\n        亦邦物流的客服人员不接受用户的口头请求对其密码进行重置。对所有用户输入的信息和上传的文件，\n        亦邦物流员工不能对其进行其他任何侵犯隐私的操作。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        4.\n        用户对其输入数据的准确性、可靠性、合法性、适用性等自行负责。用户不可破坏亦邦物流网络平台的安全或授权措施，不可翻阅或存取非自己所有的数据。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        5.\n        除应政府或司法机关调查或法律要求外，亦邦（深圳）国际物流有限公司直接口头或书面向第三方提供涉及用户在使用亦邦物流网络平台过程中保存在亦邦物流服务器上的数据的行为属于泄密行为，所造成对用户的直接损失，并经证实，用户有权通过法律途径要求亦邦物流按协议相应条款赔偿。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        6.\n        本条款中的保密义务、权利和责任不适用于如下信息：(1)非由于亦邦物流不正当的原因已经为公众所知的；(2)由亦邦物流以外其他渠道被他人获知的信息，这些渠道并不受保密义务的限制；(3)经用户授权发布的信息;\n        (4)由于法律、法院或其他国家有权机关的要求而披露的信息。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        7.\n        亦邦物流保留使用汇总统计信息的权利，但这些信息是匿名，且不针对特定用户的。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        8.\n        亦邦（深圳）国际物流有限公司保留面向基础版用户刊载广告的权利，这些广告刊载过程中将可能使用必要的定向技术来提高广告相关度，但亦邦物流不会将用户的个人信息透露给广告商，而只会在匿名的基础上通过自动化匹配技术实现广告优化刊载。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticStyle: { "font-size": "22px" } }, [
              _vm._v("不可抗力及免责条款")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        1.\n        因一切不由亦邦物流可控因素引起的服务中断和长时间终止不属于亦邦物流违约，不承担赔偿责任。不可控因素包括但不限于：\n        1）用户方客户终端硬件及网络，互联网络，机房供电系统故障；\n        2）不可抗力： 地震、台风、洪水等自然灾害；\n        战争、罢工、停电、政府行为等； 政府电力部门或电信部门的行为；\n        电信线路被人为破坏或骨干网线路、设备因调试、扩容所引起的中断；\n        INTERNET公网阻塞或其他通路（如访问目的地的服务器响应速度）问题；\n        外部人为破坏因素引起的，超过安全设备的承载能力。\n        3）其它不可预见、不可避免、不可克服和不可控制的不可抗力。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        遭受不可抗力的一方应采取一切必要措施减少损失，并在事件消除后协商恢复本合同的履行。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        2.\n        亦邦物流不保证网址所载公开信息、软件演示和免费软件服务内容的准确性、可靠性或完整性，并明确地否认就该等信息和软件功能的错误或遗漏承担责任；并不对信息和免费软件做出任何种类的保证，包括（但不限于）有关没有侵犯第三方权利、所有权、适销性、质量令人满意、适合特定的用途和没有计算机病毒的保证。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        3.\n        亦邦物流对任何损害概不负责，无论这些损害是否由于使用、不能使用本平台的结果或由连到本平台的任何Web网站或者任何这类网站中包含的信息所引起（包括但不限于由损失的利润、损失的数据或业务中断而造成的损害），也不管它们是否有保证、合同、侵权行为或任何其它法律根据以及事前已得到这类损害可能发生的消息。如果用户由于使用本站的免费信息和免费软件版本导致需要对设备或数据进行维护、修理或纠正，用户须承担由此而造成的所有费用。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        4.\n        在任何情况下，亦邦物流对于与使用或未能使用本平台或任何链接的网站免费的内容、资料、软件功能有关任何直接的、间接的、特殊的、连带的或其它损失（包括但不限于任何利润损失、业务中断以及您的信息处理系统中的信息或程序或其它数据的丢失）不向任何机构承担责任。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        5.\n        亦邦物流网络平台、论坛、博客中的所有言论并不代表亦邦物流的观点。这里所指的言论包括新闻及动态但不仅限于此。如果上面的言论对用户造成伤害，亦邦物流将协助您及有关部门依据相关法律法规清除相关内容并查找IP记录，但亦邦物流不承担任何责任。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticStyle: { "font-size": "22px" } }, [
              _vm._v("条款修订")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        1.\n        亦邦物流有权随时对本协议的条款进行修订，并在修订生效日前三个工作日更新在亦邦物流网站。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("2. 修订的条款始终公开在亦邦物流网络平台条款页面")
            ]),
            _vm._v(" "),
            _c("p", { staticStyle: { "font-size": "22px" } }, [
              _vm._v("争议解决")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        如果就本协议的解释或执行发生争议，双方应首先力争通过友好协商解决该争议。本协议在执行过程中发生争议时，双方可协商解决；不能协商解决的，可向乙方所在地人民法院提起诉讼。在上述磋商或诉讼期间，双方应继续履行争议部分之外的本合同项下各自义务。\n      "
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("serviceText")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-left" }, [
      _c("i", {
        staticClass: "el-icon-info",
        staticStyle: { color: "#5ab53c", "margin-right": "5px" }
      }),
      _vm._v("\n        系统提示\n      ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47323bf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47323bf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = null
// module chunks = 